import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=1d0357f9&scoped=true"
import script from "./roles.vue?vue&type=script&lang=js"
export * from "./roles.vue?vue&type=script&lang=js"
import style0 from "./roles.vue?vue&type=style&index=0&id=1d0357f9&prod&lang=less"
import style1 from "./roles.vue?vue&type=style&index=1&id=1d0357f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0357f9",
  null
  
)

export default component.exports